var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserCircle24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "#002147"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.023 11.878a2.936 2.936 0 000-5.87c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93v.01zM12.023 12.678c-1.34 0-2.63.54-3.58 1.49-.95.94-1.49 2.23-1.49 3.57a.273.273 0 00.27.27h9.6a.273.273 0 00.27-.27c0-1.34-.54-2.63-1.49-3.58a5.116 5.116 0 00-3.58-1.49v.01z",
    fill: "#fff"
  })));
}
export default SvgIconUserCircle24;